import './index.scss';

import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';
import * as UnifyHeight from '../assets-base/assets-src/js/Spinao/UnifyHeight';

document.addEventListener("DOMContentLoaded", function() {
    Lightgallery.applyTo('#js-lightgallery', {
        selector:'.js-lightgallery-image',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    UnifyHeight.applyDataAttribute();
});
